/*
 * @Description:
 * @Autor: lichao
 * @Date: 2021-12-27 14:49:27
 * @LastEditors: lichao
 * @LastEditTime: 2021-12-28 15:07:04
 */
import { useLocation } from 'react-router'
import {useEffect} from "react";
import Menu from "./components/Menu";
import MapFooter from "./components/MapFooter";
import { renderRoutes } from "./router/index";
import routes from "./router/routes";
import { Switch,Redirect } from "react-router-dom";
import "./App.css";

const CAPTCHA_VERIFIED_PATH = "captcha_verified_path";

/** 验证码开启时间段：每天 20:00 至次日 08:30（本地时间） */
function isCaptchaTimeWindow() {
  const now = new Date();
  const h = now.getHours();
  const m = now.getMinutes();
  if (h >= 20) return true; // 20:00 - 23:59
  if (h < 8) return true;   // 00:00 - 07:59
  if (h === 8 && m <= 30) return true; // 08:00 - 08:30
  return false;
}


function App() {
    const location = useLocation();
    useEffect(()=> {
        //友盟统计数据，单页面应用需要监听路由跳转
        const hm=document.createElement('script');
        hm.src="https://s4.cnzz.com/z_stat.php?id=1280170972&web_id=1280170972";
        const s=document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm,s)
    }, [location])
    const pathname = location.pathname;
    // 路由守卫：仅在时间段内生效；首次进入或路由变化时，未在验证码页且当前路径未在当次验证通过范围内，则先跳验证码页
    const verifiedPath =
    typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem(CAPTCHA_VERIFIED_PATH)
      : null;
  const needVerify =
    isCaptchaTimeWindow() &&
    pathname !== "/verify" &&
    pathname !== "/404" &&
    pathname !== verifiedPath;

  if (needVerify) {
    return (
      <Redirect
        to={{
          pathname: "/verify",
          state: { from: pathname },
        }}
      />
    );
  }

  return (
    <div className="App">
      <Menu></Menu>
      <Switch>{renderRoutes(routes)}</Switch>
      <MapFooter></MapFooter>
    </div>
  );
}

export default App;
